import Vue        from 'vue';
import Markdown   from 'vue-markdown-v2';
import App        from './App.vue';
import apiPlugin  from './plugins/apiPlugin';
import authPlugin from './plugins/authPlugin';
import router     from './router';

Vue.config.productionTip = false;

/*
 // Static data during development
 Vue.use(apiPlugin, {
 name:      'messengerpeople/david-api',
 resources: [
 {
 'id':                '7d30d8f1-7693-58ba-a7d3-4bde45c4fa9a',
 'name':              'Messages',
 'caption':           'Messages',
 'description':       '',
 'minimumVersion':    '',
 'hidden':            false,
 'internal':          false,
 'deprecated':        false,
 'deprecationNotice': '',
 'endpoints':         [
 {
 'caption':            'Send message',
 'bodyParameters':     [
 {
 'id':           '94fee9ea-3e4a-5999-9f07-30d8b68ef289',
 'name':         'identifier',
 'types':        [ 'string' ],
 'description':  'Sender/Recipient identifier',
 'optional':     false,
 'defaultValue': null,
 }, {
 'id':           '14f6d16e-26e0-526d-bafe-b3cab0b140d6',
 'name':         'payload',
 'types':        [ 'string' ],
 'description':  'Message payload',
 'optional':     false,
 'defaultValue': null,
 }, {
 'id':           'ab4209f5-b3be-5984-9149-086c00320f83',
 'name':         'blocking',
 'types':        [ 'bool' ],
 'description':  'Whether the message should be sent synchronous',
 'optional':     true,
 'defaultValue': 'false',
 },
 ],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        'Sends a message',
 'errors':             [],
 'hidden':             false,
 'id':                 'cfd69180-a6b3-5dd0-907f-c7d677da9470',
 'internal':           false,
 'methods':            [ 'POST' ],
 'minimumVersion':     '',
 'name':               'Send message',
 'queryParameters':    [],
 'uri':                '/messages',
 'uriArguments':       [],
 'publiclyAccessible': false,
 'scopes':             [ 'messages:send', 'messages:read' ],
 }, {
 'caption':            '',
 'bodyParameters':     [],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        'Retrieves all messages',
 'errors':             [],
 'hidden':             false,
 'id':                 'c2b7b924-c890-54e4-b902-eb8f072b301d',
 'internal':           false,
 'methods':            [ 'GET' ],
 'minimumVersion':     '',
 'name':               'index',
 'queryParameters':    [],
 'uri':                '/messages',
 'uriArguments':       [],
 'publiclyAccessible': false,
 'scopes':             [ 'messages:read' ],
 }, {
 'caption':            '',
 'bodyParameters':     [
 {
 'id':           '123daa36-c1b9-5853-b9d9-9eb69e281e3d',
 'name':         'test',
 'types':        [ 'string' ],
 'description':  'this is a param',
 'optional':     false,
 'defaultValue': null,
 },
 ],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        'Retrieves a single message',
 'errors':             [],
 'hidden':             false,
 'id':                 '85afc687-990e-5d02-adba-f9b7a9d25c47',
 'internal':           false,
 'methods':            [ 'GET' ],
 'minimumVersion':     '',
 'name':               'single',
 'queryParameters':    [],
 'uri':                '/messages/{id}',
 'uriArguments':       [
 {
 'id':           '1cef9295-de4e-5748-bd6d-c4a217e5f811',
 'name':         'id',
 'types':        [],
 'description':  '',
 'optional':     false,
 'defaultValue': null,
 },
 ],
 'publiclyAccessible': false,
 'scopes':             [ 'messages:read' ],
 },
 ],
 }, {
 'id':                'c7b6e383-b8b9-51d8-b64f-51bcc5c60544',
 'name':              'Media',
 'caption':           '',
 'description':       '',
 'minimumVersion':    '',
 'hidden':            false,
 'internal':          false,
 'deprecated':        false,
 'deprecationNotice': '',
 'endpoints':         [
 {
 'caption':            'Create media file',
 'bodyParameters':     [
 {
 'id':           '0d4339aa-c205-5932-8fc0-1a4bc68a36d6',
 'name':         'file',
 'types':        [ 'binary' ],
 'description':  'The media file to upload as a blob. The file MIME type *must* be passed in the\n         `Content-Type` header.',
 'optional':     false,
 'defaultValue': null,
 },
 ],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        'Creates a new media file\nthis is a test include file\r\n\r\nwhich spans\r\nmultiple\r\n\r\nlines!\r\n',
 'errors':             { '403': [ 'If foo is test' ], '503': [ 'Service is unavailable' ] },
 'hidden':             false,
 'id':                 'c9731521-f347-5573-af11-b7fccc5658ec',
 'internal':           false,
 'methods':            [ 'POST' ],
 'minimumVersion':     '',
 'name':               'Create media file',
 'queryParameters':    [],
 'uri':                '/media',
 'uriArguments':       [],
 'publiclyAccessible': false,
 'scopes':             [],
 }, {
 'caption':            '',
 'bodyParameters':     [],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        '',
 'errors':             [],
 'hidden':             false,
 'id':                 '32073101-4a23-5310-8cfc-6fac0a297d3a',
 'internal':           false,
 'methods':            [ 'GET' ],
 'minimumVersion':     '',
 'name':               'index',
 'queryParameters':    [],
 'uri':                '/media',
 'uriArguments':       [],
 'publiclyAccessible': false,
 'scopes':             [],
 }, {
 'caption':            '',
 'bodyParameters':     [],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        '',
 'errors':             [],
 'hidden':             false,
 'id':                 'b4bedfbf-9353-56be-9835-fef95a2cdd67',
 'internal':           false,
 'methods':            [ 'GET' ],
 'minimumVersion':     '',
 'name':               'single',
 'queryParameters':    [],
 'uri':                '/media/{id}',
 'uriArguments':       [
 {
 'id':           'ca2a51a3-2c81-5b95-b7d0-0bd872e31623',
 'name':         'id',
 'types':        [],
 'description':  '',
 'optional':     false,
 'defaultValue': null,
 },
 ],
 'publiclyAccessible': false,
 'scopes':             [],
 }, {
 'caption':            '',
 'bodyParameters':     [],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        '',
 'errors':             [],
 'hidden':             false,
 'id':                 '0f73a078-b375-5970-9be1-0c8e7115a25a',
 'internal':           false,
 'methods':            [ 'PUT' ],
 'minimumVersion':     '',
 'name':               'update',
 'queryParameters':    [],
 'uri':                '/media/{id}',
 'uriArguments':       [
 {
 'id':           'd7f81f6d-899f-5ca6-a0f7-a90e0a26ca2c',
 'name':         'id',
 'types':        [],
 'description':  '',
 'optional':     false,
 'defaultValue': null,
 },
 ],
 'publiclyAccessible': false,
 'scopes':             [],
 }, {
 'caption':            '',
 'bodyParameters':     [],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        '',
 'errors':             [],
 'hidden':             false,
 'id':                 '1265908b-5298-507b-887c-e585ad026581',
 'internal':           false,
 'methods':            [ 'DELETE' ],
 'minimumVersion':     '',
 'name':               'delete',
 'queryParameters':    [],
 'uri':                '/media/{id}',
 'uriArguments':       [
 {
 'id':           '31853dc0-614c-5cb9-8680-ee5cf74ab130',
 'name':         'id',
 'types':        [],
 'description':  '',
 'optional':     false,
 'defaultValue': null,
 },
 ],
 'publiclyAccessible': false,
 'scopes':             [],
 },
 ],
 }, {
 'id':                'd1e127c4-8da0-5557-875b-ca81568946c7',
 'name':              'Settings',
 'caption':           '',
 'description':       '',
 'minimumVersion':    '',
 'hidden':            false,
 'internal':          false,
 'deprecated':        false,
 'deprecationNotice': '',
 'endpoints':         [
 {
 'caption':            '',
 'bodyParameters':     [],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        '',
 'errors':             [],
 'hidden':             false,
 'id':                 '7c5831fc-4457-58bc-ad98-4bd71fb81a4a',
 'internal':           false,
 'methods':            [ 'PUT' ],
 'minimumVersion':     '',
 'name':               'change',
 'queryParameters':    [],
 'uri':                '/settings/{messenger}/{identifier}',
 'uriArguments':       [
 {
 'id':           'ef30a866-3bd8-5a8b-967d-322076bdf954',
 'name':         'messenger',
 'types':        [],
 'description':  '',
 'optional':     false,
 'defaultValue': null,
 }, {
 'id':           '861fc977-3c29-5bbb-b343-e111e93a6b61',
 'name':         'identifier',
 'types':        [],
 'description':  '',
 'optional':     false,
 'defaultValue': null,
 },
 ],
 'publiclyAccessible': false,
 'scopes':             [],
 },
 ],
 }, {
 'id':                'fb28e5f8-5050-51ed-9ef5-a18898124e4d',
 'name':              'Relay',
 'caption':           '',
 'description':       '',
 'minimumVersion':    '',
 'hidden':            false,
 'internal':          false,
 'deprecated':        false,
 'deprecationNotice': '',
 'endpoints':         [
 {
 'caption':            '',
 'bodyParameters':     [],
 'deprecated':         false,
 'deprecationNotice':  '',
 'description':        '',
 'errors':             [],
 'hidden':             false,
 'id':                 'd9947cb4-af7d-5385-abd7-cc09daef6969',
 'internal':           false,
 'methods':            [ 'PUT', 'POST', 'DELETE', 'GET' ],
 'minimumVersion':     '',
 'name':               'relay',
 'queryParameters':    [],
 'uri':                '/relay/{identifier}',
 'uriArguments':       [
 {
 'id':           'f4cf73f2-35cc-5105-b52d-27c1401b332f',
 'name':         'identifier',
 'types':        [],
 'description':  '',
 'optional':     false,
 'defaultValue': null,
 },
 ],
 'publiclyAccessible': false,
 'scopes':             [],
 },
 ],
 },
 ],
 });
 */
// noinspection JSUnresolvedVariable
Vue.use(apiPlugin, window.__API__);

// noinspection JSUnresolvedVariable
Vue.use(authPlugin, {
  authorizationUrl: window.__AUTH__.authorizationUrl,
  tokenUrl: window.__AUTH__.tokenUrl,
  clientId:  window.__AUTH__.clientId,
  // serverUrl: 'https://auth.david.messengerpeople.dev',
  // clientId:  'api_docs',
  storage:   window.localStorage,
});

Vue.use(Markdown);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
